import * as React from 'react';

function SvgIconContactEmpty(props) {
  return (
    <svg width={214} height={174} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M20.304 170.167c6.206 6.213 17.972 3.726 25.341-1.861 6.36-4.822 10.837-12.835 17.32-17.426 10.85-7.682 24.936-4.25 37.012 1.615 8.544 4.149 17.902 9.492 26.228 5.661 5.859-2.696 9.804-9.558 11.88-16.894 1.001-3.541 1.703-7.386 3.7-10.158 1.187-1.648 2.755-2.797 4.368-3.757 14.722-8.767 33.66-3.287 47.932-13.069 9.636-6.606 15.634-19.425 18.126-32.902 2.491-13.477 1.875-27.703.882-41.686-.705-9.938-1.821-20.556-7.075-28.365A23.568 23.568 0 00182.822 1.08c-8.327 1.294-15.793 6.554-22.324 12.833-8.17 7.833-15.686 17.667-25.846 20.641-6.92 2.026-14.273.592-21.467-.041-12.026-1.057-24.01.16-35.92 1.534-11.401 1.315-22.882 2.783-33.68 7.095-7.641 3.05-31.125 14.46-38.906 32.617-1.856 4.328-13.106 65.64 15.625 94.408z"
          fill="#E2F4F2"
        />
        <path
          d="M164 150s.904-27.285 15.389-42.703c6.08-6.47 10.073-14.686 11.13-23.578a70.89 70.89 0 00.34-12.719"
          stroke="#4C4C4C"
        />
        <path
          d="M199.693 61.777C198.645 64.878 189.88 72 189.88 72s-2.686-10.85-1.637-13.948c.678-2.005 2.396-3.503 4.507-3.93a6.104 6.104 0 015.725 1.861 5.826 5.826 0 011.218 5.792v.002zm3.902 19.874C201.046 83.691 190 85 190 85s3.682-10.514 6.231-12.55a5.896 5.896 0 019.713 3.639 5.9 5.9 0 01-2.349 5.562zm-10.504 28.313c-3.142.485-13.091-4.048-13.091-4.048s8.267-7.366 11.41-7.851c2.031-.315 4.07.53 5.346 2.215 1.276 1.685 1.596 3.955.84 5.955-.755 2-2.473 3.426-4.505 3.74v-.011zm-12.167 20.8c-3.1 1.037-13.924-1.685-13.924-1.685s7.15-8.74 10.25-9.776c3.098-1.04 6.435.683 7.453 3.848 1.018 3.165-.668 6.574-3.767 7.613h-.012z"
          fill="#38B2A6"
          fillRule="nonzero"
        />
        <path
          d="M178.654 81.538c1.502 2.86 11.095 8.462 11.095 8.462s.871-10.992-.631-13.856a5.896 5.896 0 00-4.968-3.138 5.906 5.906 0 00-5.227 2.695 5.796 5.796 0 00-.258 5.834l-.011.003zm-14.919 23.594C166.057 107.456 177 110 177 110s-2.513-10.929-4.831-13.253a5.962 5.962 0 00-8.418-.016 5.928 5.928 0 00-.016 8.398v.003zm-10.58 25.067C154.985 132.791 165 137 165 137s-.603-10.82-2.435-13.414a5.76 5.76 0 00-5.27-2.568 5.755 5.755 0 00-4.791 3.373 5.726 5.726 0 00.662 5.811l-.011-.003z"
          fill="#38B2A6"
          fillRule="nonzero"
        />
        <path
          d="M153.883 88.26c.517 1.725-.848 7.74-.848 7.74s-4.369-3.977-4.885-5.698c-.517-1.723.347-3.576 1.93-4.139 1.583-.563 3.286.378 3.803 2.1v-.002z"
          fill="#6C63FF"
          fillRule="nonzero"
        />
        <path
          d="M153.883 88.26c.517 1.725-.848 7.74-.848 7.74s-4.369-3.977-4.885-5.698c-.517-1.723.347-3.576 1.93-4.139 1.583-.563 3.286.378 3.803 2.1v-.002z"
          fill="#FFF"
          fillRule="nonzero"
          opacity={0.5}
        />
        <path fill="#4C4C4C" fillRule="nonzero" d="M151 172h23.998L181 136h-36z" />
        <path
          fill="#000"
          fillRule="nonzero"
          opacity={0.1}
          d="M149.534 136l5.533 33.64H175l-.389 2.36h-23.69L145 136z"
        />
        <g fillRule="nonzero">
          <path stroke="#E7E7E7" fill="#FFF" d="M34 17h128v156H34z" />
          <path
            d="M59 34c-6.624 0-12 5.376-12 12s5.376 12 12 12 12-5.376 12-12-5.376-12-12-12zm0 3.6c1.992 0 3.6 1.608 3.6 3.6s-1.608 3.6-3.6 3.6a3.595 3.595 0 01-3.6-3.6c0-1.992 1.608-3.6 3.6-3.6zm0 17.04a8.64 8.64 0 01-7.2-3.864c.036-2.388 4.8-3.696 7.2-3.696 2.388 0 7.164 1.308 7.2 3.696A8.64 8.64 0 0159 54.64zM59 83c-6.624 0-12 5.376-12 12s5.376 12 12 12 12-5.376 12-12-5.376-12-12-12zm0 3.6c1.992 0 3.6 1.608 3.6 3.6s-1.608 3.6-3.6 3.6a3.595 3.595 0 01-3.6-3.6c0-1.992 1.608-3.6 3.6-3.6zm0 17.04a8.64 8.64 0 01-7.2-3.864c.036-2.388 4.8-3.696 7.2-3.696 2.388 0 7.164 1.308 7.2 3.696a8.64 8.64 0 01-7.2 3.864zM59 135c-6.624 0-12 5.376-12 12s5.376 12 12 12 12-5.376 12-12-5.376-12-12-12zm0 3.6c1.992 0 3.6 1.608 3.6 3.6s-1.608 3.6-3.6 3.6a3.595 3.595 0 01-3.6-3.6c0-1.992 1.608-3.6 3.6-3.6zm0 17.04a8.64 8.64 0 01-7.2-3.864c.036-2.388 4.8-3.696 7.2-3.696 2.388 0 7.164 1.308 7.2 3.696a8.64 8.64 0 01-7.2 3.864z"
            fill="#FCCE01"
          />
          <path
            fill="#9E9E9E"
            d="M85 35h51v3H85zm0 8h51v3H85zm0 9h27v3H85zm0 34h51v3H85zm0 7h51v3H85zm0 9h27v3H85zm0 34h51v3H85zm0 9h51v3H85zm0 9h27v3H85z"
          />
        </g>
        <path
          d="M128.622 111.047c-.048.27-.192.481-.376.55h-.585l-.029.016v2.187h-.36v-2.187l-.034-.016h-.585c-.183-.07-.326-.28-.376-.55h2.345"
          fill="#E82127"
          fillRule="nonzero"
        />
        <path
          d="M137 105.8s-5.487.4-7-.8a14.083 14.083 0 006.829 3l.171-2.2z"
          fill="#000"
          fillRule="nonzero"
          opacity={0.1}
        />
      </g>
    </svg>
  );
}

export default SvgIconContactEmpty;
